import { ConditionalLink, Flex, Icons, Typography } from 'components';
import styled, { ColorsTypes } from 'styled-components';

export const CardTag = styled.span<{ color: ColorsTypes; bg: ColorsTypes }>(({ theme, color, bg }) => {
  return `
    display: flex;
    align-items: center;
    background: ${theme.colors[bg]};
    color: ${theme.colors[color]};
    font-size: 11px;
    text-transform: uppercase;
    padding: 2px 5px;
    font-weight: bold;
    border-radius: 2px;
    margin-left: 8px;
  `;
});

export const CardButton = styled.button(({ theme }) => {
  return `
    border: 0;
    height: 50px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    background: ${theme.colors.gray_600};
    display: flex;
    align-items: center;
    justify-contents: flex-start;
    padding: 0 0 0 24px;
    ${theme.fontTypes.type1}
    text-transform: uppercase;
    font-weight: ${theme.fontWeights.bold};
    position: relative;
  `;
});

export const CardButtonIcon = styled(Icons)`
  width: 24px;
  position: absolute;
  right: 24px;
`;

export const CardDescription = styled(Typography)(({ theme }) => {
  return `
    display: none;
  `;
});

export const WrapperOpacity = styled(Flex)(({ theme }) => {
  return `
    background: ${theme.colors.black30};
    border-radius: 4px;
  `;
});

export const Wrapper = styled(ConditionalLink)<{ status: 'available' | 'soon' }>(({ theme, status }) => {
  return `
    display: flex;
    width: 280px;
    height: 440px;
    border-radius: 4px;
    flex-direction: column;

    &:hover {
      ${CardDescription} {
        display: flex;
      }
    }

    ${(() => {
      if (status === 'soon') {
        return `
          ${CardButton} {
            color: ${theme.colors.gray_100};
          }
        `;
      }

      return `
        cursor: pointer;

        ${CardButton} {
          cursor: pointer;
          color: ${theme.colors.primary_400};
        }

        &:hover {
          ${CardButton} {
            background: ${theme.colors.primary_400};
            color: white;
          }
        }
      `;
    })()}
  `;
});
